import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';
import { Artist, UseArtistsResult } from '../types';

export const useArtists = (params?: {
  page?: number;
  limit?: number;
  featured?: boolean;
}): UseArtistsResult => {
  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['artists', params],
    queryFn: () => apiService.getArtists(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
  });

  return {
    artists: data?.data || [],
    isLoading,
    error: error as Error | null,
    refetch
  };
};

export const useArtistBySlug = (slug: string) => {
  return useQuery({
    queryKey: ['artist', slug],
    queryFn: () => apiService.getArtistBySlug(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useExhibitionArtists = (exhibitionId: string | null) => {
  return useQuery({
    queryKey: ['exhibitionArtists', exhibitionId],
    queryFn: () => apiService.getExhibitionArtists(exhibitionId!),
    enabled: !!exhibitionId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};